type KeywordLinkSource = {
  currentRanking?: number | null;
  mapsCanonicalUrl?: string | null;
  mapsSearchUrl?: string | null;
  searchUrl?: string | null;
  serpRanking?: number | null;
  serpSearchUrl?: string | null;
  title?: string | null;
};

export type SuperficieDaPosicao = "pesquisa" | "maps";

/**
 * De onde vem o número exibido. A rede de pesquisa é a superfície em que o
 * cliente se enxerga ("pesquisei no Google e não apareci") e as duas divergem
 * bastante — no Radar, Pitigliano Pizzaria ficou #3 no Maps e #1 na pesquisa.
 * `serpRanking` só é nulo enquanto a palavra não foi medida ali; medida e fora
 * da lista vem 0, como no Maps.
 */
export const superficieDaPosicao = ({
  serpRanking,
}: KeywordLinkSource): SuperficieDaPosicao =>
  serpRanking === null || serpRanking === undefined ? "maps" : "pesquisa";

export const rankingExibido = (keyword: KeywordLinkSource): number =>
  superficieDaPosicao(keyword) === "pesquisa"
    ? (keyword.serpRanking as number)
    : (keyword.currentRanking ?? 0);

const primeiraGravada = (...urls: Array<string | null | undefined>): string | null =>
  urls.find((url) => typeof url === "string" && url.trim().length > 0) ?? null;

/**
 * Link do "Ver link": abre a MESMA superfície do número exibido, para o cliente
 * conferir a lista que gerou a posição. Só devolve URL gravada pelo Radar —
 * montar "maps/search/<título>" fazia o Google resolver a busca na ficha de
 * outra empresa (caso GV Oficina, 01/09/2026).
 */
export const linkDaConsulta = (keyword: KeywordLinkSource): string | null =>
  superficieDaPosicao(keyword) === "pesquisa"
    ? primeiraGravada(keyword.serpSearchUrl, keyword.mapsCanonicalUrl, keyword.mapsSearchUrl)
    : primeiraGravada(keyword.mapsCanonicalUrl, keyword.mapsSearchUrl, keyword.searchUrl);
